import * as React from 'react'
import { useNavigate } from "react-router-dom"
export function Blog(props: {}) {

    const navigate = useNavigate()

    const [msgs, setMsgs] = React.useState<{ msg: string, path: string, img: string, ext: boolean }[]>([])
    React.useEffect(() => {
        fetch("/scripts/sitedata.json?100")
            .then(r => r.json().then(dat => {
                setMsgs(dat.msgs)
            }))
    }, [])
    return <React.Fragment>
        {msgs.map(m => {
            if (m.ext)
                return <div className='matte'><p>{m.msg} <a href={m.path}>See More...</a></p></div>
            else
                return <div className='matte'><p>{m.msg} <a style={{textDecoration: 'underline'}} onClick={e => navigate(`${m.path}`)}>See More...</a></p></div>
        })}
        </React.Fragment>
}